import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const AboutPage = () => {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtadilatfirmasi.com web siteniz üzerinden yazıyorum.\nTadilat, dekorasyon ve iç mimarlık hizmetleriniz hakkında bilgi ve fiyat teklifi almak istiyorum.');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-cream">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 bg-wood-dark">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mt-4 mb-6 leading-tight">
                İzmir'in Güvenilir Tadilat ve Dekorasyon Firması
              </h1>
              <p className="text-lg md:text-xl text-white/90 leading-relaxed">
                12 yılı aşkın deneyimimizle İzmir genelinde profesyonel tadilat, dekorasyon ve iç mimarlık hizmetleri sunuyoruz.
              </p>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="py-16 md:py-24">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-wood-dark mb-6">Hikayemiz</h2>
                <div className="space-y-4 text-sm md:text-base text-wood leading-relaxed">
                  <p>
                    2012 yılında İzmir'de küçük bir ekiple başladığımız yolculuğumuzda, kaliteli işçilik ve müşteri memnuniyetini her zaman ön planda tuttuk. <strong>İzmir tadilat şirketi</strong> olarak bugün 8 kişilik profesyonel ekibimizle İzmir'in her noktasında hizmet veriyoruz.
                  </p>
                  <p>
                    Özellikle <strong>Karabağlar tadilat firması</strong> olarak bölgede güçlü bir referans ağı oluşturduk. Konut, ofis ve ticari alan tadilatlarında uzmanlaşarak, her projede mükemmeliyeti hedefledik.
                  </p>
                  <p>
                    Bugün 500'den fazla mutlu müşterimiz ve tamamladığımız yüzlerce başarılı proje ile <strong>İzmir anahtar teslim tadilat</strong> alanında sektörün öncü firmalarından biri haline geldik.
                  </p>
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/a76c6fe86dd768980ecb127231b2a595.jpeg"
                  alt="İzmir tadilat firmaları arasında öncü ekip"
                  className="w-full h-[400px] md:h-[500px] object-cover rounded-3xl shadow-2xl"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="py-16 md:py-24 bg-white">
          <div className="container mx-auto px-6">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-wood-dark mb-6">Değerlerimiz</h2>
              <p className="text-sm md:text-lg text-wood max-w-2xl mx-auto">
                <strong>İzmir dekorasyon ve tadilat</strong> hizmetlerinde bizi farklı kılan temel değerlerimiz
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {[
                {
                  icon: 'ri-shield-star-line',
                  title: 'Kalite',
                  description: 'Premium malzemeler ve uzman işçilik garantisi',
                },
                {
                  icon: 'ri-time-line',
                  title: 'Zamanında Teslimat',
                  description: 'Planlanan sürede eksiksiz proje teslimi',
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: 'Müşteri Odaklı',
                  description: '7/24 destek ve şeffaf iletişim',
                },
                {
                  icon: 'ri-lightbulb-line',
                  title: 'Yenilikçilik',
                  description: 'Modern tasarım ve güncel teknolojiler',
                },
              ].map((value, index) => (
                <div key={index} className="text-center p-6 md:p-8 rounded-2xl hover:bg-cream transition-all duration-300">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 bg-wood/10 rounded-full">
                    <i className={`${value.icon} text-2xl md:text-3xl text-wood`}></i>
                  </div>
                  <h3 className="text-lg md:text-xl font-semibold text-wood-dark mb-2 md:mb-3">{value.title}</h3>
                  <p className="text-sm text-wood/80">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-16 md:py-24">
          <div className="container mx-auto px-6">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-wood-dark mb-6">Uzman Ekibimiz</h2>
              <p className="text-sm md:text-lg text-wood max-w-2xl mx-auto">
                <strong>İzmir iç mimarlık ve tadilat firması</strong> olarak deneyimli ve profesyonel ekibimizle hizmetinizdeyiz
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {[
                { role: 'Mimari Tasarım Uzmanı' },
                { role: 'Proje Koordinatörü' },
                { role: 'Uygulama Sorumlusu' },
                { role: 'Kalite Kontrol Uzmanı' },
              ].map((member, index) => (
                <div key={index} className="group text-center p-6 bg-white rounded-2xl hover:shadow-lg transition-all duration-300">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-wood/10 rounded-full">
                    <i className="ri-user-line text-3xl text-wood"></i>
                  </div>
                  <p className="text-base md:text-lg font-semibold text-wood-dark">{member.role}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 md:py-24 bg-wood-dark">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white mb-6 leading-tight">
              Projeniz İçin Hemen İletişime Geçin
            </h2>
            <p className="text-base md:text-xl text-white/90 mb-8 md:mb-10 max-w-2xl mx-auto">
              Ücretsiz keşif ve detaylı fiyat teklifi için bize ulaşın
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-4">
              <a
                href="tel:05421138110"
                className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-white hover:bg-beige text-wood-dark rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                Hemen Ara: 0542 113 81 10
              </a>
              <a
                href={`https://wa.me/905421138110?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                WhatsApp ile Yaz
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default AboutPage;
